import React from 'react';
const Example = () => (<div className="d-flex">
        <div>
            content 1 <br />
            content continues <br />
            more content
        </div>
        <span className="vertical-separator-with-text">text</span>
        <div>
            content 2 <br />
            content continues
        </div>
    </div>);
export default Example;
